@if (imageBase64) {
  <div>
    <img [src]="imageBase64" alt="Report Image" style="max-width: 100%; height: auto;" />
  </div>
} @else {
  <p>No image available.</p>
}

